import { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormGroup,
  FormControlLabel,
  Switch,
  Fab,
} from '@mui/material';

import {
  Check as CheckIcon,
} from '@mui/icons-material';

import { getDatabase, ref, set, push, update } from "firebase/database";

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";

const db = getDatabase();

export const BulkModal = (props) => {
  const { items, onClose, selected } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ value, setValue ] = useState(items[0]?.deliveries ? true : false)
  const [ currentlyUpdating, setCurrentlyUpdating ] = useState(0)
  const { updateItem, selectedStore, selectedSeason } = useContext(AuthContext);


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    if (onClose) {
      onClose();
    }
  }

  const delay = (t, val) => {
    return new Promise(resolve => setTimeout(resolve, t, val));
  }

  const handleSave = async () => {
    Tracking.track('Portal - Bulk edit Received', { items: items.length })
    let bulk_update = []

    items.forEach((item, index) => {
      bulk_update.push(() => new Promise((resolve, rejejct) => {
          setCurrentlyUpdating(index + 1)
          let deliveries_data = {
            deliveryDate: parseInt(Date.now() / 1000),
            quantity: item?.priceInfo?.quantity || 0
          }

          update(ref(db, `items/${selectedStore}/${selectedSeason}/${item.id}`), {
            '/deliveries': null,
            '/orderStatus': 1
          })
          push(ref(db, `items/${selectedStore}/${selectedSeason}/${item.id}/deliveries`), deliveries_data).then(resolve)
        })
      )
    })

    let position = 0
    let batch_size = 25
    while (position < items.length) {
      const batch = bulk_update.slice(position, position + batch_size)
      await Promise.all(batch.map((item) => item()))
      position += batch_size
    }

    // for await (const op of bulk_update) {
    //   await op();
    // }

    handleClose();
  }

  
  return (
    <Fab disableRipple disabled={!selected} color="secondary">
      {/* <div onClick={handleOpen}>Set Received</div> */}
      <CheckIcon onClick={handleOpen} />
      <Dialog onKeyDown={e => { if(e.key === 'Enter') { handleSave() } }} open={open} onClose={handleClose}>
        <DialogTitle>Mark Received?</DialogTitle>
        <DialogContent>
          {saving?(
            <DialogContentText>
              Marking items as received ({currentlyUpdating} of {items.length})
            </DialogContentText>
          ):(
            <DialogContentText>
              Mark the selected items as received?
            </DialogContentText>
          )}
          {/*  */}
          {/* <FormGroup>
            <FormControlLabel 
              control={
                <Switch 
                  checked={value}
                  onChange={(e) => setValue(e.target.checked)}
                  defaultChecked 
                />
              }
              label="Commited" 
              labelPlacement="start"
            />
          </FormGroup> */}
        </DialogContent>
        <DialogActions>
          <Button disabled={saving} onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </Fab>
  )
}